<template>
  <div>
    <ith-alert />

    <h3>Contact Us</h3>
    <form action="" class="form">
      <input
        type="text"
        class="form--mail"
        placeholder="Email"
        v-model="form.email"
      />
      <textarea
        name=""
        id="contact"
        cols="30"
        rows="7"
        class="form--text-area"
        placeholder="Message"
        v-model="form.message"
      ></textarea>
      <button class="form--btn" value="Submit" @click.prevent="sendContact()">
        Submit
      </button>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";

export default {
  data: () => ({
    form: { email: "", message: "" }
  }),
  computed: mapState(["alert"]),

  methods: {
    sendContact() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) {
        this.alert.color = "#EF3D58";
        this.alert.message = "Please, complete all fields correctly";
        this.$store.commit("editAlert", this.alert);
        return;
      } else {
        const params = {
          email: this.form.email,
          message: this.form.message
        };

        this.$Parse.Cloud.run("saveContactMessage", params)
          .then(() => {
            this.alert.color = "#94C659";
            this.alert.message = "Thanks for your feedback.";
            this.$store.commit("editAlert", this.alert);
            this.form.email = "";
            this.form.message = "";
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      message: {
        required
      }
    }
  }
};
</script>

<style scoped>
h3 {
  text-align: left;
  padding: 0px 1%;
  font-weight: 400;
  margin-top: 0px;
}
.form {
  display: grid;
  grid-template-columns: 90%;
  margin-left: 5%;
  row-gap: 10px;
}
.form--mail {
  background-color: #284060;
  padding: 7px 29px;
  border-radius: 3px;
  border: 0px;
}

.form--text-area {
  color: white;
  font-family: Montserrat, Arial;
  background-color: #284060;
  padding: 7px 29px;
  border-radius: 3px;
  border: 0px;
  resize: none;
}
.form--btn {
  color: white;
  background-color: rgba(0, 0, 0, 0);
  padding: 5px 5px;
  border-radius: 5px;
  width: 30%;
  justify-self: end;
  border: 1px solid white;
}

input::placeholder,
textarea::placeholder {
  font-size: 14px;
  color: #939292;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}
</style>
